import { render, staticRenderFns } from "./objetivosFormulario.vue?vue&type=template&id=17f113ee&"
import script from "./objetivosFormulario.vue?vue&type=script&lang=ts&"
export * from "./objetivosFormulario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports